import React from "react";
import { BottomNav, TopNav, MobileHeader } from "@/components/BottomNav";
import { FloatingCart } from "@/components/FloatingCart";

export function MobileShell({ children, showCart = true }) {
    return (
        <div className="w-full min-h-screen bg-background text-foreground">
            <TopNav />
            <MobileHeader />
            <div className="mx-auto w-full max-w-md md:max-w-6xl relative min-h-screen pb-28 md:pb-16 px-4 md:px-8 pt-4 md:pt-6">
                {children}
            </div>
            {showCart && <FloatingCart />}
            <BottomNav />
        </div>
    );
}
